import { createApp } from 'vue';
import RawToWebpConverter from '../Components/RawToWebpConverter.vue';

const root = document.getElementById('raw-to-webp-converter');
if (root) {
  createApp(RawToWebpConverter).mount('#raw-to-webp-converter');
}
